import type { SlideRole } from '../../types/api';

/**
 * The tag a slide's role earns. Only the two ends of a deck are named: a body
 * slide is the default and a tag on every one of them would be noise.
 */
export function slideRoleTag(role: SlideRole): string | null {
  if (role === 'cover') return 'Cover';
  if (role === 'closer') return 'Closer';
  return null;
}
